import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
import StyledInput, { StyledInputProps } from './StyledInput';

export default function SearchInput(props: StyledInputProps) {
  return (
    <StyledInput
      {...props}
      type={props.type ?? 'search'}
      InputProps={{
        ...(props.InputProps ?? {}),
        inputProps: {
          ...(props.InputProps?.inputProps ?? {}),
          'aria-label':
            props.InputProps?.inputProps?.['aria-label'] ?? 'Search',
          role: 'search',
        },
        endAdornment: props.InputProps?.endAdornment ?? (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        sx: {
          ...(props.InputProps?.sx ?? {}),
          backgroundColor: 'background.paper',
          borderRadius: 0.5,
          pr: 0,
          py: '2.7px',
        },
      }}
    />
  );
}
